<script>
    export let currentPage = 1;
    export let totalPages = 1;
    export let onPageChange;
  
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  </script>
  
  <div class="d-flex justify-content-end gap-2">
    {#if currentPage > 1}
      <button 
        class="btn btn-outline-primary" 
        on:click={() => onPageChange(currentPage - 1)}
      >
        Anterior
      </button>
    {/if}
  
    {#each pages as page}
      <button 
        class={`btn ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
        on:click={() => onPageChange(page)}
      >
        {page}
      </button>
    {/each}
  
    {#if currentPage < totalPages}
      <button 
        class="btn btn-outline-primary" 
        on:click={() => onPageChange(currentPage + 1)}
      >
        Siguiente
      </button>
    {/if}
  </div>
  <style>
      .pagination {
    display: flex;
    justify-content: flex-end; /* Alineamos la paginación a la derecha */
  }

 
  
  </style>